module.exports = __webpack_public_path__ + "media/images/admin2/AdminDashboardIndex__header__a-9d4f18db2449c913d5f3565dc5e1bc8f.svg";